<template>
  <button v-if="isAuth" @click="logout" class="login-btn">
    Log out
  </button>
  <a v-else :href="$getSubdomainLink('portal', '/login')" class="login-btn">
    Log in
  </a>
</template>

<script>
import { useAuthStore } from "@/stores";
export default {
    data() {
        return {
            authStore: useAuthStore(),
        };
    },
    methods: {
        logout() {
            this.authStore.logout();
        },
    },
    computed: {
        isAuth() {
            return this.authStore.isAuth;
        },
    },
};
</script>

<style
  scoped
  lang="scss"
>
.login-btn {
  color: $accent;
  display: flex;
  align-items: center;

  &:hover {
    color: $main-light;
  }
}
</style>